<template>
  <div class="forms">
    <drag-modal :visible="visible" :title='edit == 1 ? "延期" : "查看"' width='410px' class="disform" @cancel='rest'>
      <a-form-model ref="forms" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" :rules="rules">
        <a-form-model-item label="延期时间" prop="time" :rules="{ required: true, message: '请选择延期时间', trigger: 'change' }">
          <a-date-picker v-model="form.time" placeholder="请选择" style="width: 100%;" format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD" :disabled="edit == 0" />
        </a-form-model-item>
        <a-form-model-item label="延期原因" prop="reason" :rules="{ required: true, message: '请输入延期原因', trigger: 'blur' }">
          <Ntxt :content='form.reason' :max='200' Hei='108px' :edit='edit == 0'
            @contentVal='(e) => { form.reason = e }'></Ntxt>
        </a-form-model-item>
        <a-form-model-item v-if='edit == 1' style="margin-bottom:0;">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a-button type="primary" style="width: 133px;height: 32px;margin:0 0 0 74px;">
              确定
            </a-button>
          </a-popconfirm>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
    <div class="h2">
      <a-radio-group v-model="kType" @change="resh">
        <a-radio-button :value="1">提醒中({{ top.validityRemindCount }})</a-radio-button>
        <a-radio-button :value="2">已延期({{ top.validityRemindDelayCount }})</a-radio-button>
      </a-radio-group>
      <div class="mid" v-if="kType == 1">
        <a href="javascript:void(0);" :class="{ 'cur': nkType == 1 }" @click="pickMonth(1)">1个月内({{ top.aMonthsCount
        }})</a>
        <a href="javascript:void(0);" :class="{ 'cur': nkType == 2 }" @click="pickMonth(2)">3个月内({{ top.threeMonthsCount
        }})</a>
        <a href="javascript:void(0);" :class="{ 'cur': nkType == 3 }" @click="pickMonth(3)">12个月内({{ top.oneYearsCount
        }})</a>
        <a href="javascript:void(0);" :class="{ 'cur': nkType == 4 }" @click="pickMonth(4)">20个月内({{
          top.twentyMonthsCount }})</a>
        <a href="javascript:void(0);" :class="{ 'cur': nkType == 5 }" @click="pickMonth(5)">24个月内({{ top.twoYearsCount
        }})</a>
        <a href="javascript:void(0);" :class="{ 'cur': nkType == 6 }" @click="pickMonth(6)">24个月外({{
          top.twoYearsAgoCount }})</a>
      </div>
    </div>

    <div class="table">
      <Table :formKey='putData.formKey[kType]' :getUrl='putData.url'
        :query='{ type: kType, judgment_valid_time_start: tform.judgment_valid_time_start, judgment_valid_time_end: tform.judgment_valid_time_end }'
        ID='debtor_id' ref='table' :other='["cpws_id", "delay_reason"]' v-if='$common.AUTH("welcome:carry")'>
        <template v-slot:pick='v' v-if='$common.AUTH("welcome:carry:index")'>
          <div class="fbtns">
            <span v-if='$common.AUTH("debtor:info")'>
              <router-link :to='{ "name": "lydetails", params: { "id": v.id } }' class="curpoter" target="_blank"
                style='color:#1d8bfe;'> 查看 </router-link>
            </span>
            <span v-else>查看</span>
            <span @click='form.cpws_id = v.other[0]; edit = 1; visible = true;'
              v-if='kType == 1 && $common.AUTH("welcome:carry:delay")'>延期</span>
            <a-popover :content="v.other[1]" v-if='kType == 2'>
              <span>延期原因</span>
            </a-popover>
          </div>
        </template>
      </Table>
      <div class="nqx smnq" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import Table from './table.vue'
import Ntxt from '@/components/textarea/ntxt'
import { cpwsDelay } from '@/server/api'
import { diffMonth } from '@/assets/js/formData'
import { ajax } from '@/assets/js/ajax.js'
const TimeArr = [
  { now: diffMonth(-1), later: '2093-7-13' },
  { now: diffMonth(-3), later: diffMonth(-1) },
  { now: diffMonth(-12), later: diffMonth(-3) },
  { now: diffMonth(-20), later: diffMonth(-12) },
  { now: diffMonth(-24), later: diffMonth(-20) },
  { now: '1993-7-13', later: diffMonth(-24) }
]
export default {
  name: 'Carry',
  props: {
    putData: Object,
    NumList: Array
  },
  data() {
    return {
      edit: 0, //0查看 1设置
      rules: {},
      visible: false,
      nkType: null,
      topNums: [0, 0, 0, 0, 0],
      form: {
        cpws_id: null,
        time: "",
        reason: ""
      },
      kType: 1
    }
  },
  computed: {
    top() {
      return this.$store.state.Home.Top
    },
    tform() {
      if (this.nkType && this.kType == 1) {
        return {
          judgment_valid_time_start: TimeArr[this.nkType * 1 - 1].now,
          judgment_valid_time_end: TimeArr[this.nkType * 1 - 1].later
        }
      }
      else {
        return {}
      }
    }
  },
  created() {
    // this.getNums()
  },
  methods: {
    pickMonth(type) {
      if (!this.nkType || this.nkType != type) {
        this.nkType = type
      } else {
        this.nkType = null
      }
      this.resh()
    },
    // getNums() {
    //   if (!this.$common.AUTH('welcome:carry:index')) {
    //     return false;
    //   }
    //   let getCodeList = (v) => {
    //     //公共 调用
    //     return new Promise((resolve, reject) => {
    //       ajax({
    //         url: 'step/cpws/remind', //url
    //         data: {
    //           type: 1,
    //           judgment_valid_time_start: v.now,
    //           judgment_valid_time_end: v.later,
    //           page: 1,
    //           limit: 1
    //         },
    //         type: 'get',
    //         success: (e) => {
    //           resolve(e.count)
    //         },
    //       })
    //     })
    //   }
    //   let getAll = async () => {
    //     //循环抛请求
    //     let result = await Promise.all(
    //       TimeArr.map((ele) => {
    //         return getCodeList(ele)
    //       })
    //     )
    //     return result
    //   }
    //   getAll().then((res) => {
    //     //初始状态进行请求
    //     this.topNums = res
    //   })
    // },
    rest() {
      let form = JSON.parse(JSON.stringify(this.form))
      for (let val in form) {
        form[val] = ''
      }
      this.form = form
      this.visible = false;
    },
    resh() {
      setTimeout(e => {
        this.$refs.table.resh()
      }, 200)
    },
    see(v) {
      this.form.cpws_id = v.id;
      this.form.time = v.other[0]
      this.form.reason = v.other[1]
      this.visible = true;
      this.edit = 0;
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          cpwsDelay(this.form).then(e => {
            this.$message.success('已设置延期')
            this.$store.dispatch('Home/seth')
            this.$refs.table.turnpage()
            this.$store.dispatch('Home/getKey', this.NumList)
            // this.getNums()
            // this.$message.success("已设置延期")
            this.rest()
            // this.$store.dispatch('Home/seth')
            // this.$refs.table.turnpage()
            // this.$refs.table.resh()
            // this.$store.dispatch('Home/getKey', this.NumList)
          })
        } else {
          console.log("error")
        }
      })
    }
  },
  components: { Table, Ntxt }
}
</script>
<style lang="less" scoped>
.h2 {
  display: flex;
}

.mid {
  margin-left: 20px;
  overflow: hidden;

  a {
    position: relative;
    display: inline-block;
    height: 30x;
    margin: 0;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 30px;
    background: #fff;
    border: 1px solid #d9d9d9;

    &:nth-child(1) {
      border-left: 1px solid #d9d9d9;
      border-radius: 4px 0 0 4px;
    }

    &:nth-child(5) {
      border-radius: 0 4px 4px 0;
    }
  }

  .cur {
    z-index: 1;
    color: #1890ff;
    background: #fff;
    border-color: #1890ff !important;
  }
}

.disform {
  /deep/ .ant-form-item {
    margin-bottom: 14px;
  }

  /deep/ .ipt input {
    padding-right: 50px;
  }

  .file {
    width: 200px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    position: relative;
    margin-top: 4px;

    .fbox {
      position: relative;
      color: #1d8bfe;

      input {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
}
</style>